/**
 * Cabecera de `/nuestra-tienda`: la misma banda de la portada del sitio
 * (`.presentacion-tienda`: fondo crema, titulo de los banners, foto a la
 * derecha), aca con el `<h1>` de la pagina. La foto es fija
 * (`FOTO_FACHADA`): esta pagina es estatica y no se edita en el panel.
 */
import { FOTO_FACHADA, TAMANOS_FOTO_TIENDA } from '../../configuracion/foto-tienda';
import { SITIO } from '../../configuracion/sitio';
import { Icono } from '../comunes/Icono';
import { Imagen } from '../comunes/Imagen';

export interface PortadaTiendaProps {
  enlaceMaps: string;
}

export function PortadaTienda({ enlaceMaps }: PortadaTiendaProps) {
  const { url, ancho, alto, variantes } = FOTO_FACHADA;

  return (
    <section className="presentacion-tienda tienda-portada" aria-labelledby="nuestra-tienda">
      <div className="presentacion-texto">
        <p className="presentacion-antetitulo">Desde 1955 · Barrio San Diego</p>
        <h1 id="nuestra-tienda">Nuestra tienda</h1>
        <p>
          Una casa familiar que abastece a la comunidad mueblista de Chile: desde el carpintero
          tradicional hasta el arquitecto o diseñador más exigente.
        </p>
        <a className="presentacion-enlace" href={enlaceMaps} target="_blank" rel="noopener noreferrer">
          Cómo llegar a {SITIO.direccion.calle}
          <Icono nombre="flecha" />
        </a>
      </div>
      <div className="presentacion-foto">
        <Imagen
          src={url}
          alt={`Fachada de la ${SITIO.nombreLargo} en ${SITIO.direccion.calle}, ${SITIO.direccion.comuna}`}
          ancho={ancho}
          alto={alto}
          prioridad
          variantes={variantes}
          tamanos={TAMANOS_FOTO_TIENDA}
        />
      </div>
    </section>
  );
}
